export default () => ({
  messages: [],
  conversationId: null,
  activeStreamAssistantId: null,
  frozenAssistantStreamId: null,
  isSending: false,
  error: null,
  aiAccess: null,
});
